import { render, staticRenderFns } from "./AddCaseToPatient.vue?vue&type=template&id=7e075ff9&scoped=true&"
import script from "./AddCaseToPatient.vue?vue&type=script&lang=js&"
export * from "./AddCaseToPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e075ff9",
  null
  
)

export default component.exports